import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { cloneDeep } from 'lodash';

import { ModalService } from '@app/core/modal.service';
import { CustomCreditPackModalComponent as ModalComponent, ModalPublicProperties } from './custom-credit-pack-modal.component';

@Injectable({ providedIn: 'root' })
export class CustomCreditPackModalService {
  constructor(private modalService: ModalService) {}

  open(properties: ModalPublicProperties, options?: NgbModalOptions) {
    const newOptions = cloneDeep(options || {});
    newOptions.windowClass = (newOptions.windowClass || '').split(/\s+/).concat('sidemodal-right').join(' ');

    return this.modalService.open(ModalComponent, properties, newOptions);
  }
}
